import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { GetLocalStorageValues } from 'src/app/shared/util/local-storage';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private readonly ls = new GetLocalStorageValues();

  private _isOpenedSubject = new BehaviorSubject<boolean>(false);
  public isOpenedObs$: Observable<boolean> = this._isOpenedSubject.asObservable();

  private _isSideNavCollapsedSubject = new BehaviorSubject<boolean>(false);
  public isSideNavCollapsed$: Observable<boolean> = this._isSideNavCollapsedSubject.asObservable();

  constructor() {
    // Load saved collapse state from localStorage
    const savedState = localStorage.getItem('sideNavCollapsed');
    if (savedState !== null) {
      this._isSideNavCollapsedSubject.next(JSON.parse(savedState));
    }
  }

  toggleSideNav(isOpen: boolean): void {
    this._isOpenedSubject.next(!isOpen);
  }

  toggleSideNavCollapse(isCollapsed: boolean): void {
    this._isSideNavCollapsedSubject.next(isCollapsed);
    localStorage.setItem('sideNavCollapsed', JSON.stringify(isCollapsed));
  }

  getSideNavCollapseState(): boolean {
    return this._isSideNavCollapsedSubject.value;
  }
}
